class customcollection extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      var swiper = new Swiper(
        ".collection-slider--" + this.getAttribute("data-sectionid"),
        {
          slidesPerView: 1.3,
          spaceBetween: 10,
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
          navigation: {
            nextEl:
              ".swiper-button-next-new--" + this.getAttribute("data-sectionid"),
            prevEl:
              ".swiper-button-prev-new--" + this.getAttribute("data-sectionid"),
          },
          breakpoints: {
            640: {
              slidesPerView: 2.2,
              spaceBetween: 20,
            },
            768: {
              slidesPerView: 2.5,
              spaceBetween: 30,
            },
            990: {
              slidesPerView: 3,
              spaceBetween: 30,
            },
            1149: {
              slidesPerView: 4,
              spaceBetween: 40,
            },
          },
        }
      );
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("custom-collection", customcollection);

class testimonialnew extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      var swiper = new Swiper(
        ".testimonial-slider--" + this.getAttribute("data-sectionid"),
        {
          slidesPerView: 1,
          loop: true,
          spaceBetween: 10,
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
          breakpoints: {
            640: {
              slidesPerView: 2,
              spaceBetween: 20,
            },
            768: {
              slidesPerView: 3,
              spaceBetween: 30,
            },
            1149: {
              slidesPerView: 4,
              spaceBetween: 40,
            },
          },
        }
      );
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("testimonial-new", testimonialnew);

class productslider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      var swiper = new Swiper(
        ".product-slider--" + this.getAttribute("data-sectionid"),
        {
          slidesPerView: 1.3,
          spaceBetween: 10,
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
          navigation: {
            nextEl:
              ".swiper-button-next--" + this.getAttribute("data-sectionid"),
            prevEl:
              ".swiper-button-prev--" + this.getAttribute("data-sectionid"),
          },
          breakpoints: {
            640: {
              slidesPerView: 2.2,
              spaceBetween: 20,
            },
            768: {
              slidesPerView: 2.5,
              spaceBetween: 30,
            },
            990: {
              slidesPerView: 3,
              spaceBetween: 30,
            },
            1149: {
              slidesPerView: 4,
              spaceBetween: 40,
            },
          },
        }
      );
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("product-slider", productslider);

class collectionslider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      var swiper = new Swiper(
        ".product-slider1--" + this.getAttribute("data-sectionid"),
        {
          slidesPerView: 1.3,
          spaceBetween: 10,
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
          navigation: {
            nextEl:
              ".swiper-button-next--" + this.getAttribute("data-sectionid"),
            prevEl:
              ".swiper-button-prev--" + this.getAttribute("data-sectionid"),
          },
          breakpoints: {
            640: {
              slidesPerView: 2.2,
              spaceBetween: 20,
            },
            768: {
              slidesPerView: 2.5,
              spaceBetween: 30,
            },
            990: {
              slidesPerView: 3,
              spaceBetween: 30,
            },
            1149: {
              slidesPerView: 4,
              spaceBetween: 40,
            },
          },
        }
      );

      var swiper = new Swiper(
        ".product-slider2--" + this.getAttribute("data-sectionid"),
        {
          slidesPerView: 1.3,
          spaceBetween: 10,
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
          navigation: {
            nextEl:
              ".swiper-button-next--" + this.getAttribute("data-sectionid"),
            prevEl:
              ".swiper-button-prev--" + this.getAttribute("data-sectionid"),
          },
          breakpoints: {
            640: {
              slidesPerView: 2.2,
              spaceBetween: 20,
            },
            768: {
              slidesPerView: 2.5,
              spaceBetween: 30,
            },
            990: {
              slidesPerView: 3,
              spaceBetween: 30,
            },
            1149: {
              slidesPerView: 4,
              spaceBetween: 40,
            },
          },
        }
      );

      var swiper = new Swiper(
        ".collection-title--" + this.getAttribute("data-sectionid"),
        {
          slidesPerView: "auto",
          spaceBetween: 20,
          freeMode: true,
        }
      );
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("collection-slider", collectionslider);

class brightmediacontent extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      $(document).ready(function () {
        var video = $(".myVideo--" + this.getAttribute("data-sectionid"))[0];
        $(".muteBtn--" + this.getAttribute("data-sectionid"))
          .find(".mute")
          .hide();
        $(".muteBtn--" + this.getAttribute("data-sectionid"))
          .find(".unmute")
          .show();
        $(".muteBtn--" + this.getAttribute("data-sectionid")).click(
          function () {
            if (video.muted) {
              video.muted = false;
              $(".muteBtn--" + this.getAttribute("data-sectionid"))
                .find(".mute")
                .hide();
              $(".muteBtn--" + this.getAttribute("data-sectionid"))
                .find(".unmute")
                .show();
            } else {
              video.muted = true;
              $(".muteBtn--" + this.getAttribute("data-sectionid"))
                .find(".mute")
                .show();
              $(".muteBtn--" + this.getAttribute("data-sectionid"))
                .find(".unmute")
                .hide();
            }
          }
        );
      });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("bright-media-content", brightmediacontent);

class ourteam extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      var swiper = new Swiper(
        ".gallery--" + this.getAttribute("data-sectionid"),
        {
          slidesPerView: 1.3,
          spaceBetween: 10,
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
          navigation: {
            nextEl:
              ".swiper-button-next--" + this.getAttribute("data-sectionid"),
            prevEl:
              ".swiper-button-prev--" + this.getAttribute("data-sectionid"),
          },
          breakpoints: {
            640: {
              slidesPerView: 2.2,
              spaceBetween: 20,
            },
            768: {
              slidesPerView: 2.5,
              spaceBetween: 30,
            },
            990: {
              slidesPerView: 3,
              spaceBetween: 30,
            },
            1149: {
              slidesPerView: 4,
              spaceBetween: 40,
            },
          },
        }
      );
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("our-team", ourteam);

class imageslider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      var swiper = new Swiper(
        ".slider--" + this.getAttribute("data-sectionid"),
        {
          spaceBetween: 30,
          pagination: {
            el: ".swiper-pagination",
          },
          navigation: {
            nextEl:
              ".swiper-button-next--" + this.getAttribute("data-sectionid"),
            prevEl:
              ".swiper-button-prev--" + this.getAttribute("data-sectionid"),
          },
        }
      );
 
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("image-slider", imageslider);
